import styled from 'styled-components'
import Spinner from '../Spinner'

import Text from 'components/Text'
import { DynamicContainer } from 'components'

interface Props {
  message?: string
  isDynamicHeight?: boolean
}

const SpinnerMessage = ({ message }: { message?: string }) => (
  <Container>
    <Spinner fontSize={80} />
    {message && (
      <Text color="gray5" fontSize={14} lineHeight="24px" mb={16}>
        {message}
      </Text>
    )}
  </Container>
)

const LoadingView = ({ message, isDynamicHeight }: Props) => {
  if (isDynamicHeight) {
    return (
      <DynamicContainer>
        <SpinnerMessage message={message} />
      </DynamicContainer>
    )
  }
  return <SpinnerMessage message={message} />
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  height: 100%;
  width: 100%;
  gap: 1rem;
`

export default LoadingView
